import { CONTACT_DIRECTORY_SCOPE } from "@/libraries/constant";
import { fallback } from "@tanstack/router-zod-adapter";
import { z } from "zod";
import { DataIdSchema } from "./auth";

export const GetTeamsParamsSchema = z.object({
	page: z.number().default(1).optional(),
	limit: z.number().default(25).optional(),
	search: z.string().optional(),
	directory: z.boolean().default(false).optional(),
	scope: z
		.nativeEnum(CONTACT_DIRECTORY_SCOPE)
		.default(CONTACT_DIRECTORY_SCOPE.ALL_TEAMS)
		.optional(),
});

export type GetTeamsParamsSchema = z.infer<typeof GetTeamsParamsSchema>;

export const TeamPageSearchSchema = z.object({
	q: z.string().optional(),
	scope: fallback(z.nativeEnum(CONTACT_DIRECTORY_SCOPE), "all_teams").default(
		CONTACT_DIRECTORY_SCOPE.ALL_TEAMS,
	),
	notAuthorized: z.boolean().optional(),
});

export type TeamPageSearchSchema = z.infer<typeof TeamPageSearchSchema>;

export const CreateGroupSchema = z.object({
	avatar: z.any().optional(),
	name: z.string().min(1, "Group name is required"),
	organization: z.string().optional(),
	synopsis: z.string().max(100, "Synopsis is too long").optional(),
	location: z.string().max(100, "Synopsis is too long").optional(),
	directory: z.boolean().optional(),
	member_ids: z.array(z.number().int()).optional(),
});

export type CreateGroupSchema = z.infer<typeof CreateGroupSchema>;

export const UpdateGroupSchema = CreateGroupSchema.partial().merge(
	z.object({
		id: z.number().int(),
	}),
);

export type UpdateGroupSchema = z.infer<typeof UpdateGroupSchema>;

export const SyncGroupParamsSchema = z.object({
	last_requested_at: z.number().int().optional(),
	status: z.enum(["active", "closed"]).optional(),
	groupIds: z.array(z.number().int()).optional(),
	page: z.number().default(1).optional(),
	limit: z.number().default(25).optional(),
});
export type SyncGroupParamsSchema = z.infer<typeof SyncGroupParamsSchema>;

export const UpdateTeamFieldSchema = z.object({
	id: DataIdSchema,
	user_ids: DataIdSchema.array().optional(),
	name: z.string().trim().min(1, "Name is required"),
	directory: z.boolean().default(false),
});
export type UpdateTeamFieldSchema = z.infer<typeof UpdateTeamFieldSchema>;

export const CreateTeamFormSchema = z.object({
	name: z.string().min(1, "Name is required").max(100).trim(),
	user_ids: z.set(z.number()),
	directory: z.boolean().optional(),
	without_members_response: z.boolean().optional(),
});
export type CreateTeamFormSchema = z.infer<typeof CreateTeamFormSchema>;
